import CloudGamingPage from "./cloud-gaming.page";

export default CloudGamingPage;
